import { render, staticRenderFns } from "./VideoDetails.vue?vue&type=template&id=5227954e&scoped=true&"
import script from "./VideoDetails.vue?vue&type=script&lang=js&"
export * from "./VideoDetails.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetails.vue?vue&type=style&index=0&id=5227954e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227954e",
  null
  
)

export default component.exports